var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.pageCount > 1)?_c('div',{staticClass:"cn-pagination"},[_c('div',{staticClass:"cn-pagination__block"},[_c('nav',{staticClass:"cn-pagination__nav",attrs:{"aria-label":"Pagination"}},[(_vm.currentPage !== 1)?_c('NuxtLink',{staticClass:"cn-pagination__prev",attrs:{"to":{
          query: {
            ..._setup.route.query,
            ...(_vm.currentPage > 2
              ? { page: _vm.currentPage - 1 }
              : { page: undefined }),
          },
        }}},[_c('span',{staticClass:"sr-only"},[_vm._v("Previous")]),_vm._v(" "),_c('UiIcon',{attrs:{"name":"chevron-left","aria-hidden":"true"}})],1):_vm._e(),_vm._v(" "),_vm._l((_setup.pages),function(page){return [(page)?[(page.breakView)?_c('span',{key:`${page.content} separator`,staticClass:"cn-pagination__separator"},[_vm._v("\n            ...\n          ")]):_c('NuxtLink',{key:page.content,staticClass:"cn-pagination__page",class:[{ 'cn-pagination__page--selected': page.selected }],attrs:{"to":{
              query: {
                ..._setup.route.query,
                page: page.index > 0 ? page.index + 1 : undefined,
              },
            }}},[_vm._v("\n            "+_vm._s(page.content)+"\n          ")])]:_vm._e()]}),_vm._v(" "),(_vm.currentPage < _vm.pageCount)?_c('NuxtLink',{staticClass:"cn-pagination__next",attrs:{"tabindex":"0","to":{
          query: {
            ..._setup.route.query,
            page: _vm.currentPage + 1,
          },
        }}},[_c('span',{staticClass:"sr-only"},[_vm._v("Next")]),_vm._v(" "),_c('UiIcon',{attrs:{"name":"chevron-right","aria-hidden":"true"}})],1):_vm._e()],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }